import { JetView } from 'webix-jet';
import { devConfig } from 'config/config';

/**
 * Class representing a view for generating tokens.
 * @extends JetView
 */
export default class FilterGenerateTokenView extends JetView {
    /**
     * Configures the view layout and components.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const screen = this.app.config.size; // Screen size configuration

        // Left section containing a date picker
        const center_left = {
            margin: 5,
            rows: [
                {
                    view: 'text', // Text input for date selection
                    name: 'Datepicker',
                    id: 'Datepicker',
                    css: 'reportrange',
                    readonly: true, // Read-only input
                    label: "<span class='webix_icon icon-calendar'></span>" + _('Fecha'), // Label with icon
                    labelPosition: 'top',
                    placeholder: _('Click para seleccionar '), // Placeholder text
                },
            ],
        };

        // Right section (currently empty)
        const center_right = {
            margin: 5,
            rows: [],
        };

        // Additional right section (currently empty)
        const right = {
            margin: 5,
            rows: [],
        };

        // Upper section layout combining left and a spacer
        const upper_section = {
            cols: [
                center_left,
                { gravity: 2, minWidth: 10 }, // Spacer
            ],
        };

        // Button section with action buttons
        const buttons = {
            margin: 2,
            cols: [
                {},
                {
                    view: 'button', // Button to generate token
                    value: _('Generar Token'),
                    width: 120,
                    click: () => {
                        const cur_user = this.getParam('user', true); // Get current user ID
                        const filterdata = this.getRoot().getValues(); // Get form values
                        var thisClick = this; // Reference to the current context

                        // AJAX request to save user security
                        webix
                            .ajax()
                            .headers({
                                'Content-type': 'application/json', // Set content type
                            })
                            .post(
                                devConfig.geturlApi() + '/UserManagement/SaveUserSecurity',
                                '{ "UserId":' + cur_user + '}', // Request body
                                {
                                    error: function (text, data, XmlHttpRequest) {
                                        webix.message('Error'); // Error message on failure
                                    },
                                    success: function (text, data, XmlHttpRequest) {
                                        var json = JSON.parse(text); // Parse response
                                        webix.message('Saved'); // Success message
                                        thisClick.app.callEvent('generateTokenAgentList:filter', [filterdata]); // Trigger filter event
                                    },
                                },
                            );
                    },
                },
                {
                    view: 'button', // Button to clear the form
                    value: _('Limpiar'),
                    width: 66,
                    click: () => {
                        this.getRoot().clear(); // Clear form values
                    },
                },
                {
                    view: 'button', // Button to consult/filter data
                    value: _('Consultar'),
                    hotkey: 'enter', // Hotkey for the button
                    type: 'form',
                    width: 84,
                    click: () => {
                        const filterdata = this.getRoot().getValues(); // Get form values
                        this.app.callEvent('generateToken:filter', [filterdata]); // Trigger filter event
                    },
                },
            ],
        };

        // Return the complete form configuration
        return {
            view: 'form',
            rows: [upper_section, buttons], // Combine upper section and buttons
            rules: {
                fname: webix.rules.isNotEmpty, // Validation rule for the form
            },
        };
    }
}

// FILE DOCUMENTED
